export const EXSBDOCUMENT_DELETE_RESET = 'EXSBDOCUMENT_DELETE_RESET'
export const EXSBDOCUMENT_DELETE_SET_ERROR = 'EXSBDOCUMENT_DELETE_SET_ERROR'
export const EXSBDOCUMENT_DELETE_SET_DELETED = 'EXSBDOCUMENT_DELETE_SET_DELETED'
export const EXSBDOCUMENT_DELETE_TOGGLE_LOADING = 'EXSBDOCUMENT_DELETE_TOGGLE_LOADING'
